import { Pagination } from "react-bootstrap";
import { FaAngleLeft, FaAngleRight, FaAnglesLeft, FaAnglesRight } from "react-icons/fa6";

const PaginationComponent = ({ currentPage, totalPages, onPageChange }) => {
  const pageItems = [];
  const getPageNumbers = () => {
    const pages = [];

    if (totalPages <= 5) {
      for (let i = 1; i <= totalPages; i++) {
        pages.push(i);
      }
    } else {
      if (currentPage <= 3) {
        pages.push(1, 2, 3, 4, "...", totalPages);
      } else if (currentPage >= totalPages - 2) {
        pages.push(1, "...", totalPages - 3, totalPages - 2, totalPages - 1, totalPages);
      } else {
        pages.push(1, "...", currentPage - 1, currentPage, currentPage + 1, "...", totalPages);
      }
    }

    return pages;
  };

  const pageNumbers = getPageNumbers();

  return (
    <div className="notification-pagination d-flex justify-content-center pt-1">
      <Pagination>
        <Pagination.First onClick={() => onPageChange(1)} disabled={currentPage === 1}>
          <FaAnglesLeft />
        </Pagination.First>

        <Pagination.Prev onClick={() => onPageChange(currentPage - 1)} disabled={currentPage === 1}>
          <FaAngleLeft />
        </Pagination.Prev>

        {pageNumbers.map((number, idx) =>
          number === "..." ? (
            <Pagination.Ellipsis key={idx} disabled />
          ) : (
            <Pagination.Item
              key={idx}
              active={number === currentPage}
              onClick={() => onPageChange(number)}
            >
              {number}
            </Pagination.Item>
          )
        )}

        <Pagination.Next onClick={() => onPageChange(currentPage + 1)} disabled={currentPage === totalPages}>
          <FaAngleRight />
        </Pagination.Next>

        <Pagination.Last onClick={() => onPageChange(totalPages)} disabled={currentPage === totalPages}>
          <FaAnglesRight />
        </Pagination.Last>
      </Pagination>
    </div>
  );
};

export default PaginationComponent;
